import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./locales/de.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: ["de", "en"],
    detection: {
      // Browser language first, then whatever the user picked manually last time.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "seatingplan.locale",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
